// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"SwiperA_thecomp__ezzqM"};